jQuery(document).ready(function ($) {
    /**
      * If the table of contents block is not present on the page, then do not execute the code below.
      */
    if (!$(".fixed-anchor-menu-module").length) {
        return;
    }

    const isAutomaticGenerationEnabled = $(".fixed-anchor-menu-module").hasClass("generation-type-auto");
    const upperboundElementRef = $(".fixed-anchor-menu-module").attr("data-upperbound");
    const lowerboundElement = $(".fixed-anchor-menu-module").attr("data-lowerbound");
    let upperbound = 0;
    let lowerbound = 0;

    /**
     * If the generation mode is set to "auto", then generate the anchor menu contents automatically
     * based on the headings in the content. Otherwise, update the heading IDs only.
     */
    if ( isAutomaticGenerationEnabled ) {
        autoGenerateAnchorMenuLinks();
    } else {
        updateHeadingIds();
    }

    /** 
     * Store the scroll top positions of the headings in the content area.
    */
    var headingsScrollTopPositions = [];
    loadHeadingsScrollTopPositions();
    updateUpperAndLowerBounds();
    updateFixedAnchorMenuPosition($(window).scrollTop());

    $(window).on("load", function () {
        loadHeadingsScrollTopPositions();
        updateUpperAndLowerBounds();
        updateFixedAnchorMenuPosition($(window).scrollTop());
    });

    /**
     * On window resize, reload the scroll top positions of the headings in the content area
     */
    $(window).resize(function () {
        loadHeadingsScrollTopPositions();
        updateUpperAndLowerBounds();
        updateFixedAnchorMenuPosition($(window).scrollTop());
    });

    /**
     * On page scroll, highlight the anchor menu link based on the heading in the content area.
     */
    $(window).on("scroll", function () {
        let scrollPosition = $(window).scrollTop();
        let activeHeading = headingsScrollTopPositions[0]?.id;
        for (let i = 0; i < headingsScrollTopPositions.length; i++) {
            if (scrollPosition >= headingsScrollTopPositions[i].offset) {
                activeHeading = headingsScrollTopPositions[i].id;
            }
        }
        $(".fixed-anchor-menu-module a").removeClass("active");
        $(`.fixed-anchor-menu-module a[href="#${activeHeading}"]`).addClass("active");
        updateFixedAnchorMenuPosition(scrollPosition);
    });

    /**
      * On click of a anchor menu link, scroll to the corresponding heading in the content
      */
    $(".fixed-anchor-menu-module").on("click", "a", function (event) {
        event.preventDefault();
        $(this).addClass("active").siblings().removeClass("active");
        let target = $(this).attr("href");
        let offset = $(target).offset().top - 240;
        $("html, body").animate({ scrollTop: offset }, 500);
    });

    function updateFixedAnchorMenuPosition(scrollPosition) {
        if (scrollPosition <= upperbound) {
            $(".fixed-anchor-menu-module").removeClass("fixed").css("top", upperbound + "px");
        } else if (scrollPosition >= lowerbound - 240) {
            $(".fixed-anchor-menu-module").removeClass("fixed").css("top", lowerbound + "px");
        } else {
            $(".fixed-anchor-menu-module").addClass("fixed").css("top", "");
        }
    }

    /**
     * Update the upper and lower bounds of the fixed anchor menu.
     * @return {void}
     */
    function updateUpperAndLowerBounds() {
        upperbound = $(upperboundElementRef).offset().top + $(upperboundElementRef).outerHeight(true) + 20;
        lowerbound = $(lowerboundElement).offset().top - $(".fixed-anchor-menu-module").outerHeight(true) - 20;
    }

    /**
     * Load the scroll top positions of the headings in the content area.
     * @return {void}
     */
    function loadHeadingsScrollTopPositions() {
        headingsScrollTopPositions = [];
        if ( !isAutomaticGenerationEnabled ) {
            $(".fixed-anchor-menu-module a").each(function (index, element) {
                const anchor = $(element);
                let target = anchor.attr("href");
                if ( !$(target).length ) {
                    return;
                }
                let offset = $(target).offset().top - 250;
                let id = target.replace("#", "");
                headingsScrollTopPositions.push({ id, offset });
            });
            return;
        }

        $("h2, h3, h4, h5, h6", "body section.wrapper").each(function (index, element) {
            const heading = $(element);
            let text = heading.text().trim();
            let id = text.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s/g, '-');
            let offset = heading.offset().top - 250;
            headingsScrollTopPositions.push({ id, offset });
        });
    }

    /**
     * Update the heading IDs inside the content area of the page.
     * @return {void}
     */
    function updateHeadingIds() {
        $("h2, h3, h4, h5, h6", "body section.wrapper").each(function (index, element) {
            const heading = $(element);
            let text = heading.text().trim();
            let id = text.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s/g, '-');
            heading.attr("id", id);
        });
    }

    /**
     * Generate the anchor menu links automatically.
     * @return {void}
     */
    function autoGenerateAnchorMenuLinks() {
        $("h2, h3", "body section.wrapper").each(function (index, element) {
            const heading = $(element);
            let text = heading.text().trim();
            let id = text.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s/g, '-');
            heading.attr("id", id);
            let classes = index === 0 ? `active` : "";
            $(".fixed-anchor-menu-module").append(`<a class="${classes}" href="#${id}">${text}</a>`);
        });
    }
});